import { render, staticRenderFns } from "./FieldType6Configure.vue?vue&type=template&id=4a86d608&scoped=true"
import script from "./FieldType6Configure.vue?vue&type=script&lang=js"
export * from "./FieldType6Configure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a86d608",
  null
  
)

export default component.exports